// IMPORTANT Autogenerated file
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CorrectiveMaintenanceActionDto } from '@ellf/common-dto';
import { ApiClientConfig } from '../api-client-config';
import { BaseCRUDApiClient } from './baseCRUD.api-client';

@Injectable()
export class CorrectiveMaintenanceActionApiClient extends BaseCRUDApiClient<CorrectiveMaintenanceActionDto> {
  baseUrl = this.config.apiEndpoint + '/corrective-maintenance-action';

  constructor(http: HttpClient, config: ApiClientConfig) {
    super(http, config);
  }
}
